module.exports = __webpack_public_path__ + "dist/media/head.d65dac74.mp4";